// How much clock the player wants.
//
// Two separate settings, deliberately, because they answer two different
// questions. `timed` is "do I want a clock at all" — for a player who finds a
// ticking bar stressful rather than exciting, and for whom the honest answer is
// no timer, not a generous one. `timeScale` is "how long should that clock be"
// for the player who does want one.
//
// NOT every mode can honour `timed: false`. In Last Gasp the sixty seconds IS
// the game, and in Endurance the score is a TIME — switching the clock off
// there does not make an easier mode, it makes no mode. Those two stay timed
// and say so on their own screens. Everything else asks `paced()` for its
// duration and `timed` for whether to run at all.

import { computed } from 'vue';
import { profile } from './profile.js';

/** Does this player want a clock in the modes that can go without one? */
export const timed = computed(() => profile.value.timed !== false);

/** Multiplier on every per-question limit. 1 is the designed pace. */
export const timeScale = computed(() => {
  const n = Number(profile.value.timeScale);
  return Number.isFinite(n) && n > 0 ? n : 1;
});

/** The clock a mode should actually run, given the settings. */
export function paced(baseMs) {
  return Math.round(baseMs * timeScale.value);
}

/** Offered on the settings screen. Labels stay in the app's voice. */
export const TIME_SCALES = [
  { value: 0.5, label: 'Brisk', hint: 'Half the time. Show off.' },
  { value: 1, label: 'Normal', hint: 'The pace it was designed at.' },
  { value: 2, label: 'Relaxed', hint: 'Double the time to think.' },
];
